/* NKS mobile bottom navigation bar (Home / Series / Search / Cart / Account).
   Shown below 750px only. Cart opens the theme's cart drawer; Home / Series / Search / Account are
   plain links. The footer menus start expanded on phones via data-open in sections/footer.liquid. */
(function () {
  'use strict';
  if (window.__nksBottomNav) return;
  window.__nksBottomNav = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var T = { home: 'Home', series: 'Series', search: 'Search', cart: 'Cart', account: 'Account', nav: 'Bottom navigation' };
  var mqlSmall = window.matchMedia('(max-width: 749px)');

  var ICON = {
    home: '<path d="M3 10.5 12 3l9 7.5"/><path d="M5.5 9v11h13V9"/><path d="M10 20v-6h4v6"/>',
    series: '<rect x="3.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="3.5" y="13.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="13.5" width="7" height="7" rx="1.5"/>',
    search: '<circle cx="10.5" cy="10.5" r="6.5"/><path d="m15.5 15.5 5 5"/>',
    cart: '<path d="M3 4h2.2l2.3 11.2a1.5 1.5 0 0 0 1.5 1.2h8.6a1.5 1.5 0 0 0 1.5-1.1L21 8H6.2"/><circle cx="9.5" cy="20" r="1.3"/><circle cx="17" cy="20" r="1.3"/>',
    account: '<circle cx="12" cy="8.5" r="4"/><path d="M4 20.5c1.4-3.6 4.4-5.5 8-5.5s6.6 1.9 8 5.5"/>'
  };

  var css = '' +
    '.nks-bnav{display:none}' +
    '@media (max-width:749px){' +
      '.nks-bnav{display:flex;position:fixed;left:0;right:0;bottom:0;z-index:90;background:rgba(255,255,255,.97);' +
        '-webkit-backdrop-filter:saturate(1.4) blur(10px);backdrop-filter:saturate(1.4) blur(10px);' +
        'border-top:1px solid rgba(60,16,83,.12);box-shadow:0 -6px 18px rgba(60,16,83,.08);' +
        'padding:6px 4px calc(6px + env(safe-area-inset-bottom));justify-content:space-around;transition:transform .25s ease}' +
      '.nks-bnav__item{flex:1 1 0;display:flex;flex-direction:column;align-items:center;gap:3px;padding:4px 0;' +
        'color:#3c1053;text-decoration:none;background:none;border:0;font:inherit;cursor:pointer;position:relative;-webkit-tap-highlight-color:transparent}' +
      '.nks-bnav__item svg{width:23px;height:23px;fill:none;stroke:currentColor;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round}' +
      '.nks-bnav__label{font-size:10.5px;letter-spacing:.04em;line-height:1;font-weight:600}' +
      '.nks-bnav__item[aria-current="page"]{color:#7a3fa8}' +
      '.nks-bnav__item[aria-current="page"]::before{content:"";position:absolute;top:-6px;width:22px;height:2px;border-radius:2px;background:#7a3fa8}' +
      '.nks-bnav__badge{position:absolute;top:0;left:calc(50% + 6px);min-width:16px;height:16px;padding:0 4px;border-radius:8px;' +
        'background:#3c1053;color:#fff;font-size:10px;font-weight:700;line-height:16px;text-align:center}' +
      '.nks-bnav__badge:empty{display:none}' +
      'body{padding-bottom:calc(62px + env(safe-area-inset-bottom))}' +
      'body.nks-bnav-hide .nks-bnav,body:has(animate-sticky[animate]) .nks-bnav{transform:translateY(110%)}' +
    '}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function svg(name) { return '<svg viewBox="0 0 24 24" aria-hidden="true">' + ICON[name] + '</svg>'; }
  function item(tag, key, href) {
    var el = document.createElement(tag);
    el.className = 'nks-bnav__item';
    if (href) el.href = href; else el.type = 'button';
    el.setAttribute('data-nks', key);
    el.innerHTML = svg(key) + '<span class="nks-bnav__label">' + T[key] + '</span>';
    return el;
  }

  // the header bubble holds the visible count plus a visually-hidden "N items" label; read the visible part only
  function cartCount() {
    var b = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!b) return '';
    var n = ((b.querySelector('[aria-hidden="true"]') || b).textContent || '').replace(/\D/g, '');
    return n && n !== '0' ? n : '';
  }

  function build() {
    if (document.querySelector('.nks-bnav')) return;
    var nav = document.createElement('nav');
    nav.className = 'nks-bnav notranslate';
    nav.setAttribute('aria-label', T.nav);

    var home = item('a', 'home', root);
    var series = item('a', 'series', root + 'pages/series');
    var search = item('a', 'search', root + 'search');
    var cart = item('button', 'cart');
    var account = item('a', 'account', root + 'account');
    var badge = document.createElement('span'); badge.className = 'nks-bnav__badge'; cart.appendChild(badge);

    var p = location.pathname.replace(/\/$/, '') || '/';
    var r = root.replace(/\/$/, '') || '/';
    if (p === r) home.setAttribute('aria-current', 'page');
    else if (p.indexOf('/pages/series') > -1 || p.indexOf('/collection') > -1 || p.indexOf('/products/') > -1) series.setAttribute('aria-current', 'page');
    else if (p.indexOf('/cart') > -1) cart.setAttribute('aria-current', 'page');
    else if (p.indexOf('/account') > -1) account.setAttribute('aria-current', 'page');
    else if (p.indexOf('/search') > -1) search.setAttribute('aria-current', 'page');

    cart.addEventListener('click', function () {
      var c = document.querySelector('#cart-icon-bubble');
      var trigger = c && (c.closest('summary') || c.closest('a') || c);
      if (trigger && !/\/cart$/.test(location.pathname)) trigger.click(); else location.href = root + 'cart';
    });

    [home, series, search, cart, account].forEach(function (el) { nav.appendChild(el); });
    document.body.appendChild(nav);

    function syncBadge() { var n = cartCount(); if (badge.textContent !== n) badge.textContent = n; }
    syncBadge();
    var hdrCart = document.querySelector('#cart-icon-bubble');
    if (hdrCart) new MutationObserver(syncBadge).observe(hdrCart, { childList: true, subtree: true, characterData: true });
    document.addEventListener('cart:updated', syncBadge);

    // keep the bar out of the way while a drawer / modal is open. Drawers toggle a class on <html>/<body> and the
    // open attribute on their <details>, so watch those two elements plus details toggles instead of the whole tree.
    function syncHidden() {
      if (!mqlSmall.matches) return;
      var open = document.querySelector('details[open] > .search-modal, mini-cart details[open], details.mini-cart[open], .menu-drawer-container[open], details[open].menu-drawer-container, html.overflow-hidden, body.overflow-hidden, body.overflow-hidden-tablet');
      if (document.body.classList.contains('nks-bnav-hide') !== !!open) document.body.classList.toggle('nks-bnav-hide', !!open);
    }
    var watch = new MutationObserver(syncHidden);
    watch.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    watch.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('toggle', syncHidden, true);
  }

  function init() { build(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
